import React from 'react';
import { ToastContainer } from 'react-toastify';
import { useWeb3Modal } from '@web3modal/ethers5/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { toastConfig } from '../../config/toastConfig';
import MintingInterface from '../mint/MintingInterface';
import TermsPage from '../modals/TermsPage';
import { useContractState } from '../../hooks/useContractState';
import { ImagePreloader } from '../common/ImagePreloader';

import "react-toastify/dist/ReactToastify.css";

const MainApp = () => {
    const modal = useWeb3Modal();
    const {
        state,
        updateState,
        handleMint,
        handleClaim,
        getButtonState,
        showTerms,
        setShowTerms,
        handleTermsAccept
    } = useContractState();

    return (
        <div className="min-h-screen flex items-center justify-center">
            <ToastContainer {...toastConfig} />

            <MintingInterface
                state={state}
                updateState={updateState}
                handleMint={handleMint}
                handleClaim={handleClaim}
                getButtonState={getButtonState}
                modal={modal}
                showTerms={showTerms}
                setShowTerms={setShowTerms}
                handleTermsAccept={handleTermsAccept}
            />
        </div>
    );
};

const App = () => {
    return (
        <Router>
            <ImagePreloader onComplete={(success) => {
                if (!success) {
                    console.warn('Some images failed to preload');
                }
            }}>
                <Routes>
                    <Route path="/" element={<MainApp />} />
                    <Route path="/terms" element={<TermsPage />} />
                </Routes>
            </ImagePreloader>
        </Router>
    );
};

export default App;